import { Component } from '@angular/core';

/**
 * Loader de vidro do Admin (agj-one-loading-app-full-page, no One), trazido para o link público: cartão de vidro
 * flutuando, com um líquido mudando de forma por dentro, um brilho atrás e o "Já carregando". Só CSS: sai certo no
 * HTML do SSR, antes do JS. Diferente do Admin, segue a paleta da empresa nos dois modos (pedido do dono, revendo a
 * decisão #60 do plano 3, que deixava loader só na cor da marca). Sem movimento, o cartão segue flutuando como sinal
 * de espera (base/motion.scss).
 */
@Component({
  selector: 'agj-liquid-loader',
  templateUrl: './liquid-loader.component.html',
  styleUrl: './liquid-loader.component.scss',
  host: { 'aria-hidden': 'true' }
})
export class LiquidLoaderComponent {}
